import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=3766c213&scoped=true&"
import script from "./AddTeam.vue?vue&type=script&lang=js&"
export * from "./AddTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766c213",
  null
  
)

export default component.exports